import { render, staticRenderFns } from "./AccountInformation.vue?vue&type=template&id=2b89c524&"
import script from "./AccountInformation.vue?vue&type=script&lang=js&"
export * from "./AccountInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports